export default __webpack_public_path__ + "static/TSD_Blog_Overview_Recession-e03b8454742aac24efe9fd30e9e6040c.jpg";